import React, { useState } from "react";
import {
  Paper,
  Typography,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Button,
  Box,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import styles from "./merchants.css";

const Merchants = () => {
  const [payoutAccount, setPayoutAccount] = useState("Payout Account A");
  const [debitAmount, setDebitAmount] = useState("10000");
  const fees = 100;
  return (
    <Paper elevation={1} className={"tableContainer"}>
      {/* Balance */}
      <Typography className={styles.masterBalance}>
        <span style={{ color: "#79747E", paddingRight: "5px" }}>
          Enable/disable merchants
        </span>
      </Typography>

      {/* Form */}
      <Box className={"formContainer"}>
        <Typography className={"type"}>Select A/c type</Typography>
        <FormControl component="fieldset" sx={{ marginLeft: 2 }}>
          <RadioGroup row defaultValue="collect" name="transaction-type">
            <FormControlLabel
              value="collect"
              control={<Radio />}
              label="Collect"
            />
            <FormControlLabel
              value="payout"
              control={<Radio />}
              label="Payout"
            />
          </RadioGroup>
        </FormControl>
        <Typography className={"type"}>Select status</Typography>
        <FormControl component="fieldset" sx={{ marginLeft: 2 }}>
          <RadioGroup row defaultValue="collect" name="transaction-type">
            <FormControlLabel
              value="Enable"
              control={<Radio />}
              label="Enable"
            />
            <FormControlLabel
              value="Disable"
              control={<Radio />}
              label="Disable"
            />
            <FormControlLabel
              value="Suspend"
              control={<Radio />}
              label="Suspend"
            />
          </RadioGroup>
        </FormControl>
        <Box className={"row"}>
          <Typography className={"label"}>Account Name</Typography>
          <Typography className={"colon"}>:</Typography>
          <FormControl size="small" className={"inputWrapper"}>
            <Select
              value={payoutAccount}
              onChange={(e) => setPayoutAccount(e.target.value)}
              fullWidth
            >
              <MenuItem value="Payout Account A">Prashnath</MenuItem>
              <MenuItem value="Payout Account B">Nethaji</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box className={"row"}>
          <Typography className={"label"}>Transfer Amount</Typography>
          <Typography className={"colon"}>:</Typography>
          <TextField
            size="small"
            value={debitAmount}
            onChange={(e) => setDebitAmount(e.target.value)}
            InputProps={{
              endAdornment: <InputAdornment position="end">₹</InputAdornment>,
            }}
            fullWidth
          />
        </Box>
        <Box className={"row"}>
          <Typography className={"label"}>Current status</Typography>
          <Typography className={"colon"}>:</Typography>
          <Typography className={"value"}>Enabled</Typography>
        </Box>
        {/* Submit */}
        <Box className={"submitContainer"}>
          <Button
            variant="contained"
            className={"submitButton"}
            onClick={() => console.log("Submit clicked")}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default Merchants;
